import { format, formatDistanceToNow } from 'date-fns';

export const formatDateTime = (date: string) => {
	return formatDistanceToNow(new Date(date), {
		addSuffix: true,
	}).replace(/^\w/, (c) => c.toUpperCase());
};

export const formatSourceHeaderDate = (date: string) => {
	return format(new Date(date), 'dd-MM-yyyy');
};
